import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

export default class tableConceptsView extends JetView {
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current context
        var datePopup = []; // Placeholder for date popup (not used in this fragment)
        return {
            view: 'datatable', // Defines the view type as a datatable
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
            columns: [
                // Column definitions for the datatable
                {
                    id: 'rating', // Unique identifier for the column
                    header: '', // Header text (empty in this case)
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Editar'), // Tooltip text for the column
                    template: function(obj) {
                        // Template function for rendering the column
                        if (devConfig.getPermAction('accountingConceptsEdit', 'Edit')) {
                            return '<span class=\'webix_icon wxi-close edit\'></span>'; // Icon for editing if permission is granted
                        } else {
                            return ''; // No icon if permission is denied
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // Column for ID with sorting
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' }, // Column for Name with localization and sorting
                {
                    id: 'Reference',
                    header: _('Referencia'), // Column for Reference with localization
                    width: 250,
                    sort: 'int', // Sorting enabled
                },
                {
                    id: 'AccountName',
                    header: _('Plan de cuenta'), // Column for Account Name with localization
                    width: 250,
                    sort: 'int', // Sorting enabled
                },
                {
                    id: 'Account',
                    header: _('Cuenta Id'), // Column for Account ID with localization
                    width: 250,
                    sort: 'int', // Sorting enabled
                },
                {
                    id: 'Type',
                    header: _('Tipo'), // Column for Type with localization
                    editor: 'combo', // Combo editor for selecting type
                    options: [
                        // Options for the combo editor
                        { id: 'E', value: _('Egreso') }, // Option for 'Egreso'
                        { id: 'I', value: _('Ingreso') }, // Option for 'Ingreso'
                    ],
                    width: 100,
                    sort: 'int', // Sorting enabled
                },
                {
                    id: 'CashBaseMovement',
                    header: {
                        text: _('¿Es de movimiento de base de caja?'), // Column header with localization
                        height: 40, // Header height
                    },
                    editor: 'combo', // Combo editor for selecting cash base movement
                    options: [
                        // Options for the combo editor
                        { id: '0', value: _('Si') }, // Option for 'Yes'
                        { id: '1', value: _('No') }, // Option for 'No'
                    ],
                    width: 150,
                    sort: 'int', // Sorting enabled
                },
                {
                    id: 'BetShopId',
                    header: _('Punto de Venta'), // Column for Bet Shop ID with localization
                    editor: 'combo', // Combo editor for selecting Bet Shop
                    options: {
                        // Options for the combo editor
                        body: {
                            dataFeed: function(text) {
                                // Function to fetch data for the combo
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Fetch data if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint for fetching Bet Shops
                                            '{"Filter":"' + text + '"}', // Request payload with filter
                                            {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse the response
                                                    if (!resp.HasError) {
                                                        // Check for errors in the response
                                                        vthis.parse(resp.Data); // Parse and display the data
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                    width: 100,
                    sort: 'int', // Sorting enabled
                },
            ],
            onClick: {
                edit: function(euv, id) {
                    // Event handler for edit icon click
                    vthis.app.callEvent('openEdit', [{}]); // Trigger 'openEdit' event
                },
            },
            on: {
                onBeforeLoad: function() {
                    // Event before loading data
                    this.showOverlay(
                        // Show loading overlay
                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                    );
                },
                onAfterLoad: function() {
                    // Event after data has loaded
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Preload data configuration
            pager: 'pagerA', // Identifier for the pager component
            url: devConfig.geturlApi() + 'Accounting/GetConcepts', // API endpoint for fetching concepts
        };
    }

    /**
     * Initializes the grid with data and UI components.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data fetching
        var filter = ''; // Filter for data
        var datePopup = []; // Array to hold data for popup
        var popup = ''; // Variable to hold the edit popup
        var popupAdd = ''; // Variable to hold the add popup

        // AJAX request to fetch account data
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetAccountsSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Show error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse the response
                    datePopup = resp.Data; // Store the data for the popup
                    popup = webix.ui({
                        view: 'window', // Create a window for editing concepts
                        id: 'EditConcepts',
                        width: 390,
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Editar Concepto') }, // Label for editing
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function() {
                                        this.getTopParentView().hide(); // Hide the popup on close
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Make the popup modal
                        body: {
                            view: 'form', // Form for editing
                            id: 'editForm',
                            elements: [
                                {
                                    view: 'text',
                                    label: 'ID',
                                    name: 'Id',
                                    readonly: true, // ID field is read-only
                                },
                                {
                                    view: 'text',
                                    label: _('Nombre'),
                                    name: 'Name',
                                    readonly: true, // Name field is read-only
                                },
                                {
                                    view: 'text',
                                    label: _('Referencia'),
                                    name: 'Reference',
                                    readonly: true, // Reference field is read-only
                                },
                                {
                                    view: 'combo',
                                    label: _('ID Plan de Cuentas'),
                                    name: 'Account',
                                    readonly: true, // Account field is read-only
                                },
                                {
                                    view: 'combo',
                                    label: _('Tipo'),
                                    name: 'Type',
                                    options: [
                                        { id: 'E', value: _('Egresos') }, // Expense type
                                        { id: 'I', value: _('Ingresos') }, // Income type
                                    ],
                                    readonly: true, // Type field is read-only
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo',
                                            name: 'BetShopId',
                                            label: _('Punto de Venta'),
                                            labelWidth: 150,
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                            id: 'selectBetShopId2',
                                            options: {
                                                body: {
                                                    dataFeed: function(text) {
                                                        var vthis = this; // Reference to the current context
                                                        if (text.length > 2) {
                                                            // Trigger data fetch if input length is greater than 2
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type for the request
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                                    '{"Filter":"' + text + '"}', // Send filter text
                                                                    {
                                                                        error: function(text, data, XmlHttpRequest) {
                                                                            webix.message('Error! '); // Show error message on failure
                                                                        },
                                                                        success: function(text, data, XmlHttpRequest) {
                                                                            var resp = JSON.parse(
                                                                                text, // Parse the response
                                                                            );
                                                                            if (
                                                                                !resp.HasError // Check for errors in response
                                                                            ) {
                                                                                vthis.parse(
                                                                                    resp.Data, // Parse data into the combo
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                },
                                            },
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button',
                                            view: 'button',
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass', // Icon for search button
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({
                                                        view: 'window', // Create a window for searching Bet Shops
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Punto de Venta'), // Label for Bet Shop search
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close', // Close icon
                                                                    click: function() {
                                                                        this.getTopParentView().hide(); // Hide the search popup on close
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchBetShop2',
                                                        modal: true, // Make the search popup modal
                                                        position: 'center', // Center the popup
                                                        width: 390,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying Bet Shops
                                                                    select: true,
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id',
                                                                                {
                                                                                    content: 'textFilter', // Enable text filtering
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'), // Column header for Name
                                                                                {
                                                                                    content: 'textFilter', // Enable text filtering
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Allow column to fill space
                                                                        },
                                                                    ],
                                                                    data: profile.BetShops, // Load Bet Shops data
                                                                    on: {
                                                                        onItemDblClick: function(id) {
                                                                            var item = this.getItem(
                                                                                id, // Get the clicked item
                                                                            );
                                                                            $$('selectBetShopId2').setValue(
                                                                                item.id, // Set the selected Bet Shop ID
                                                                            );
                                                                            $$('searchBetShop2').hide(); // Hide the search popup
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Show the search popup
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'checkbox',
                                    label: _('¿Es de movimiento de base de caja?'), // Checkbox for cash base movement
                                    labelWidth: 250,
                                    name: 'CashBaseMovement',
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Cancel button
                                            click: function() {
                                                this.getTopParentView().hide(); // Hide the edit popup on cancel
                                                $$('editForm').setValues(
                                                    $$('editForm').getCleanValues(), // Reset form values
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Save button
                                            click: function($e) {
                                                var values = $$('editForm').getValues(); // Get form values
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for the request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Accounting/SaveConcept',
                                                        '{"Id":"' +
                                                        values.Id +
                                                        '", "Name":"' +
                                                        values.Name +
                                                        '","Reference":"' +
                                                        values.Reference +
                                                        '", "AccountId":"' +
                                                        values.Account +
                                                        '", "Type":"' +
                                                        values.Type +
                                                        '", "BetShopId":"' +
                                                        values.BetShopId +
                                                        '", "CashBaseMovement":"' +
                                                        values.CashBaseMovement +
                                                        '"}', // Send data to save
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message on failure
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Concepto Actualizado')); // Show success message
                                                                grid.clearAll(); // Clear the grid
                                                                grid.load(
                                                                    url +
                                                                    '?start=0&count=' +
                                                                    grid.data.$pagesize +
                                                                    filter, // Reload grid data
                                                                );
                                                            },
                                                        },
                                                    );
                                                $$('editForm').setValues(
                                                    $$('editForm').getCleanValues(), // Reset form values
                                                );
                                                this.getTopParentView().hide(); // Hide the edit popup
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                    $$('editForm').bind($$('datatable')); // Bind the form to the data table
                    popupAdd = webix.ui({
                        view: 'window', // Create a window for adding concepts
                        width: 390,
                        id: 'AddConcepts',
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Añadir Concepto') }, // Label for adding
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function() {
                                        this.getTopParentView().hide(); // Hide the popup on close
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Make the popup modal
                        body: {
                            view: 'form', // Form for adding
                            id: 'addform',
                            elements: [
                                {
                                    view: 'text',
                                    label: _('Nombre'), // Name field
                                    name: 'Name',
                                    labelWidth: 150,
                                },
                                {
                                    view: 'text',
                                    label: _('Referencia'), // Reference field
                                    name: 'Reference',
                                    labelWidth: 150,
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo',
                                            label: _('ID Plan de Cuentas'), // Account selection field
                                            name: 'Account',
                                            options: datePopup, // Options populated from fetched data
                                            labelWidth: 150,
                                            id: 'selectAccount',
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                        },
                                        {
                                            width: 30, // Width of the button
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Type of UI component
                                            type: 'icon', // Button type
                                            icon: 'icon-magnifying-glass', // Icon to be displayed on the button
                                            align: 'center', // Alignment of the button
                                            click: () => {
                                                // Click event handler for the button
                                                webix
                                                    .ui({
                                                        view: 'window', // Creates a window UI component
                                                        head: {
                                                            view: 'toolbar', // Toolbar for the window header
                                                            cols: [
                                                                {
                                                                    view: 'label', // Label in the toolbar
                                                                    label: _(
                                                                        'Plan de Cuentas', // Title of the window
                                                                    ),
                                                                    align: 'center', // Center alignment for the label
                                                                },
                                                                {
                                                                    view: 'icon', // Close icon in the toolbar
                                                                    icon: 'wxi-close', // Icon for closing the window
                                                                    click: function() {
                                                                        // Click event to close the window
                                                                        this.getTopParentView().hide(); // Hides the window
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchAccount', // Unique ID for the window
                                                        modal: true, // Modal window
                                                        position: 'center', // Center position for the window
                                                        width: 390, // Width of the window
                                                        height: 425, // Height of the window
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying accounts
                                                                    select: true, // Enable row selection
                                                                    columns: [
                                                                        {
                                                                            id: 'id', // Column ID for account ID
                                                                            header: [
                                                                                'Id', // Header label
                                                                                {
                                                                                    content: 'textFilter', // Filter type for the column
                                                                                },
                                                                            ],
                                                                            width: 70, // Width of the column
                                                                        },
                                                                        {
                                                                            id: 'value', // Column ID for account name
                                                                            header: [
                                                                                _(
                                                                                    'Nombre', // Header label for account name
                                                                                ),
                                                                                {
                                                                                    content: 'textFilter', // Filter type for the column
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Column will fill remaining space
                                                                        },
                                                                    ],
                                                                    data: datePopup, // Data source for the table
                                                                    on: {
                                                                        // Event handler for double-click on a row
                                                                        onItemDblClick: function(
                                                                            id, // ID of the clicked item
                                                                        ) {
                                                                            var item = this.getItem(
                                                                                id, // Get the item data
                                                                            );
                                                                            $$(
                                                                                // Set the selected account ID
                                                                                'selectAccount',
                                                                            ).setValue(item.id);
                                                                            $$(
                                                                                // Hide the search window
                                                                                'searchAccount',
                                                                            ).hide();
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    }).show();
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'combo', // Combo box for selecting type
                                    label: _('Tipo'), // Label for the combo box
                                    name: 'Type', // Name of the combo box
                                    options: [
                                        {
                                            id: 'E',
                                            value: _('Egresos'),
                                        }, // Option for expenses
                                        {
                                            id: 'I',
                                            value: _('Ingresos'),
                                        }, // Option for income
                                    ],
                                    labelWidth: 150, // Width of the label
                                    placeholder: _('Click para seleccionar '), // Placeholder text
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Combo box for selecting BetShop
                                            name: 'BetShopId', // Name of the combo box
                                            label: _('Punto de Venta'), // Label for the combo box
                                            labelWidth: 150, // Width of the label
                                            placeholder: _(
                                                'Click para seleccionar ', // Placeholder text
                                            ),
                                            id: 'selectBetShopId', // Unique ID for the combo box
                                            options: {
                                                body: {
                                                    dataFeed: function(text) {
                                                        // Function to fetch data for the combo box
                                                        var vthis = this; // Reference to the current context
                                                        if (text.length > 2) {
                                                            // Trigger data fetch if input length is greater than 2
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type for the request
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                    'es/Select/BetShopsSelect', // API endpoint
                                                                    '{"Filter":"' + text + '"}', // Request payload
                                                                    {
                                                                        error: function(
                                                                            text,
                                                                            data,
                                                                            XmlHttpRequest, // Error handler for the request
                                                                        ) {
                                                                            webix.message(
                                                                                'Error! ', // Display error message
                                                                            );
                                                                        },
                                                                        success: function(
                                                                            text,
                                                                            data,
                                                                            XmlHttpRequest, // Success handler for the request
                                                                        ) {
                                                                            var resp = JSON.parse(
                                                                                text, // Parse the response
                                                                            );
                                                                            if (
                                                                                !resp.HasError // Check for errors in the response
                                                                            ) {
                                                                                vthis.parse(
                                                                                    resp.Data, // Populate the combo box with data
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                },
                                            },
                                        },
                                        {
                                            width: 30, // Width of the button
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Type of UI component
                                            type: 'icon', // Button type
                                            icon: 'icon-magnifying-glass', // Icon to be displayed on the button
                                            align: 'center', // Alignment of the button
                                            click: () => {
                                                // Click event handler for the button
                                                webix
                                                    .ui({
                                                        view: 'window', // Creates a window UI component
                                                        head: {
                                                            view: 'toolbar', // Toolbar for the window header
                                                            cols: [
                                                                {
                                                                    view: 'label', // Label in the toolbar
                                                                    label: _(
                                                                        'Punto de Venta', // Title of the window
                                                                    ),
                                                                    align: 'center', // Center alignment for the label
                                                                },
                                                                {
                                                                    view: 'icon', // Close icon in the toolbar
                                                                    icon: 'wxi-close', // Icon for closing the window
                                                                    click: function() {
                                                                        // Click event to close the window
                                                                        this.getTopParentView().hide(); // Hides the window
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchBetShop', // Unique ID for the window
                                                        modal: true, // Modal window
                                                        position: 'center', // Center position for the window
                                                        width: 390, // Width of the window
                                                        height: 425, // Height of the window
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying BetShops
                                                                    select: true, // Enable row selection
                                                                    columns: [
                                                                        {
                                                                            id: 'id', // Column ID for BetShop ID
                                                                            header: [
                                                                                'Id', // Header label
                                                                                {
                                                                                    content: 'textFilter', // Filter type for the column
                                                                                },
                                                                            ],
                                                                            width: 70, // Width of the column
                                                                        },
                                                                        {
                                                                            id: 'value', // Column ID for BetShop name
                                                                            header: [
                                                                                _(
                                                                                    'Nombre', // Header label for BetShop name
                                                                                ),
                                                                                {
                                                                                    content: 'textFilter', // Filter type for the column
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Column will fill remaining space
                                                                        },
                                                                    ],
                                                                    data: profile.BetShops, // Data source for the table
                                                                    on: {
                                                                        // Event handler for double-click on a row
                                                                        onItemDblClick: function(
                                                                            id, // ID of the clicked item
                                                                        ) {
                                                                            var item = this.getItem(
                                                                                id, // Get the item data
                                                                            );
                                                                            $$(
                                                                                // Set the selected BetShop ID
                                                                                'selectBetShopId',
                                                                            ).setValue(item.id);
                                                                            $$(
                                                                                // Hide the search window
                                                                                'searchBetShop',
                                                                            ).hide();
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Show the window
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'checkbox', // Checkbox for cash base movement
                                    label: _(
                                        '¿Es de movimiento de base de caja?', // Label for the checkbox
                                    ),
                                    labelWidth: 250, // Width of the label
                                    name: 'CashBaseMovement', // Name of the checkbox
                                    value: 0, // Default value (unchecked)
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button', // Button for cancel action
                                            value: _('Cancelar'), // Button label
                                            click: function() {
                                                // Click event handler for the button
                                                this.getTopParentView().hide(); // Hide the current view
                                                $$('addform').setValues(
                                                    // Reset the form values
                                                    $$('addform').getCleanValues(),
                                                );
                                            },
                                        },
                                        {
                                            view: 'button', // Button for save action
                                            type: 'form', // Button type
                                            value: _('Guardar'), // Button label
                                            click: function($e) {
                                                // Click event handler for the button
                                                var values = $$('addform').getValues(); // Get form values
                                                console.log(
                                                    'CashBaseMovement ' + values.CashBaseMovement, // Log the cash base movement value
                                                );
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for the request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Accounting/SaveConcept', // API endpoint
                                                        '{"Name":"' +
                                                        values.Name +
                                                        '","Reference":"' +
                                                        values.Reference +
                                                        '", "AccountId":"' +
                                                        values.Account +
                                                        '", "Type":"' +
                                                        values.Type +
                                                        '", "BetShopId":"' +
                                                        values.BetShopId +
                                                        '", "CashBaseMovement":"' +
                                                        values.CashBaseMovement +
                                                        '"}', // Request payload
                                                        {
                                                            error: function(
                                                                text,
                                                                data,
                                                                XmlHttpRequest, // Error handler for the request
                                                            ) {
                                                                webix.message(
                                                                    _('Error! '), // Display error message
                                                                );
                                                            },
                                                            success: function(
                                                                text,
                                                                data,
                                                                XmlHttpRequest, // Success handler for the request
                                                            ) {
                                                                webix.message(
                                                                    _(
                                                                        'Concepto Agregado', // Display success message
                                                                    ),
                                                                );
                                                                grid.clearAll(); // Clear the grid data
                                                                grid.load(
                                                                    url +
                                                                    '?start=0&count=' +
                                                                    grid.data.$pagesize +
                                                                    filter, // Reload grid data
                                                                );
                                                            },
                                                        },
                                                    );
                                                $$('addform').setValues(
                                                    // Reset the form values
                                                    $$('addform').getCleanValues(),
                                                );
                                                this.getTopParentView().hide(); // Hide the current view
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });


                },
            });

        /**
         * Event handler for filtering concepts.
         * @param {Object} filterData - The data used for filtering.
         */
        this.on(this.app, 'concepts:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
        });

        /**
         * Event handler for sorting the grid.
         * @param {string} by - The column to sort by.
         * @param {string} dir - The direction of the sort (asc/desc).
         * @param {Object} as - Additional sorting options.
         */
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        /**
         * Event handler for adding concepts.
         * @param {Object} filter - The filter data.
         */
        this.on(this.app, 'addConcepts:button', (filter) => {
            if (datePopup.length > 0) {
                $$('addform').clearValidation();
                popupAdd.show();
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        /**
         * Event handler for opening the edit popup.
         * @param {Object} filterData - The data used for filtering.
         */
        this.on(this.app, 'openEdit', (filterData) => {
            if (datePopup.length > 0) {
                popup.show();
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
